<bn-loading-overlay></bn-loading-overlay>
<div class="row" *ngIf="podeEscolherAgente">
  <div class="col">
    <h4>Consulta de valores de limites aportados</h4>
    <h5>Limite atual do fundo <span *ngIf="dataLimitePesquisa" class="letra-miuda">&nbsp;&nbsp;&nbsp;atualizado em: {{ dataLimitePesquisa }}</span></h5>
  </div>

  <div class="col-auto">
    <button type="button" class="btn btn-primary" (click)="abrirModalAporteLegado()" *ngIf="podeImportarArquivoLegado" placement="top"
        ngbTooltip="Realiza a importação dos valores comprometidos existentes no sistema legado FGI">
        <i class="fa fa-file"></i> Importar Legado
    </button>
  </div>

</div>


<div class="row" *ngIf="podeEscolherAgente">
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Limite</th>
          <th class="text-end">Valor subscrito</th>
          <th class="titulo-moeda">Limite garantia*</th>
          <th class="titulo-moeda">Comprometido atual</th>
          <th class="titulo-moeda" container="body" ngbTooltip="Valor comprometido existente no sistema legado FGI">
            Comprometido legado</th>
          <th class="titulo-moeda">Valor disponível</th>
        <tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Global
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteAportado?.valorSubscrito | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteAportado?.valorLimiteGarantia | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteAportado?.comprometido | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteAportado?.comprometidoLegado | bnMask:'MOEDA' }}
          </td>
          <td [ngClass]="'moeda'">
            {{ limiteAportado?.valorDisponivel | bnMask:'MOEDA' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="modalidade && podeEscolherAgente" class="letra-miuda">* {{ modalidade.textoObservacaoLimiteTotal }}</div>

<br>

<h5>Limite por agente financeiro</h5>

<div class="container">
    <div class="row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>

      <div class="col-auto">
        <button type="button" class="btn btn-light align-self-end" (click)="limparPesquisa()">Limpar</button>

        <button type="button"
        class="btn btn-success align-self-end" style="margin-left: 20px;" (keydown.enter)="buscar()" (click)="buscar()">Pesquisar</button>
      </div>
    </div>

    <div class="bn-form-group row">
     <div class="bn-form-group col-md-8">
        <label for="agenteFinanceiro">Agente Financeiro:</label>

        <select *ngIf="!podeEscolherAgente" disabled (change)="atribuiAgenteFinanceiro($event.target.value)" id="agenteFinanceiro" class="form-select">
        <ng-container *ngFor="let agente of agentesFinanceiros">
          <option selected *ngIf="agente.cnpj == cnpjUsuario" [value]="agente.cnpj">{{ agente.nome + ' (' + agente.cnpj + ')'}}</option>
        </ng-container>
        </select>

        <ng-select
          *ngIf="podeEscolherAgente"
          [(ngModel)]="cnpjAgentePesquisa"
          id="agenteFinanceiro"
          [items]="agentesFinanceiros"
          bindLabel="nome"
          bindValue="cnpj"
          placeholder="Todos"
          class="auto-grow"
          (change)="atribuiAgenteFinanceiro()">
          <ng-template ng-label-tmp let-item="item">
            {{ item.nome + ' (' + item.cnpj + ')' }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" container="body">
            {{ item.nome + ' (' + item.cnpj + ')' }}
          </ng-template>
        </ng-select>
      </div>
    </div>
</div>


<ng-template #bodyAporte>
  <form>
    <div class="row">
      <div class="bn-form-group align-self-center col-sm-3">
        <label class="form-label"> Arquivo a ser importado:</label>
      </div>

      <div class="bn-form-group col-sm-6">
        <bn-file-uploader #uploaderArquivoSistemaLegadoAporte [autoUpload]="false" [form]="true" [tipoPermitido]="'.txt'"
          [quantidadeArquivosPorLinha]="1" [tamanhoMaximo]="40" [descricao]="false" [numeroMaximoArquivos]="1"
          ngbTooltip="Anexar até 01 arquivo com no máximo 40Mbytes" placement="left" [edicao]="true">
        </bn-file-uploader>
      </div>
      <br />
    </div>
  </form>
</ng-template>



<ng-template #botoesAporte>
  <button class="btn btn-danger" (click)="close()">Fechar</button>
  <button class="btn btn-primary" (click)="importarArquivoLegadoAporte()">Importar</button>
</ng-template>


<app-limite-contratacao-listagem
    [agenteFinanceiro]="agenteFinanceiroPesquisa"
	  [refresh]="refresh"
    [limpar]="limpar"
    (exportarLista)="exportarLista()">
</app-limite-contratacao-listagem>
